import React, { useEffect } from "react";

export default function MobileMenuDrawer({
  open,
  onClose,
  onOpenAuth,
  onSelectMenuItem,
}) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose?.();
    }
    if (!open) return undefined;
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const items = ["Home", "About", "Subscription", "Profile", "Contact", "Settings"];

  return (
    <div className="fixed inset-0 z-50">
      <button
        type="button"
        aria-label="Close menu"
        onClick={onClose}
        className="absolute inset-0 bg-black/25"
      />

      <aside className="absolute right-0 top-0 h-full w-72 bg-white shadow-xl">
        <div className="flex items-center justify-end px-4 py-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-full p-2 text-slate-500 hover:bg-slate-100"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <nav className="px-5 pb-5 text-sm text-slate-700">
          <ul className="space-y-3">
            {items.map((label) => (
              <li key={label}>
                <button
                  type="button"
                  className="w-full text-left hover:text-indigo-600"
                  onClick={() => {
                    onSelectMenuItem?.(label.toLowerCase());
                    onClose?.();
                  }}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>

          <div className="my-4 h-px bg-slate-200" />

          <div className="space-y-2">
            <button
              type="button"
              className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-800 hover:border-indigo-500 hover:text-indigo-600"
              onClick={() => {
                onClose?.();
                onOpenAuth?.("login");
              }}
            >
              Login
            </button>
            <button
              type="button"
              className="w-full rounded-xl bg-indigo-600 px-3 py-2 text-sm font-semibold text-white hover:bg-indigo-700"
              onClick={() => {
                onClose?.();
                onOpenAuth?.("signup");
              }}
            >
              Sign up
            </button>
          </div>
        </nav>
      </aside>
    </div>
  );
}

